import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'
import { StarLiteFragment } from '@src/graphql/fragment/star'

export default gql`
  query GetStars(
    $filterInput: GetStarsFilterInput!
    $pagingInput: PagingInput
    $sortInput: StarSortInput!
  ) {
    getStars(
      filterInput: $filterInput
      pagingInput: $pagingInput
      sortInput: $sortInput
    ) {
      edges {
        cursor
        node {
          ...StarLite
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${StarLiteFragment}
  ${PageInfoFragment}
`
